//
//
//
//
//
//

import BtnLink from '../components/BtnLink.vue';
import BtnControl from '../components/BtnControl.vue';

export default {
	name: 'btn',

	components: { BtnLink: BtnLink, BtnControl: BtnControl },

	props: {
		prevent: {
			type: Boolean,
			default: false
		},

		link: {
			default: false
		},
		replace: {
			default: false
		},
		tag: {
			default: 'link'
		},
		query: {
			default: null
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/Btn.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/Btn.vue
// module chunks = 5